export default "__VITE_ASSET__BRxRsZol__"